
import { useEffect, useState } from "react";
import axios from "axios";
import ConsultaUsuario from "../ConsultaUsuario";
import { ErroMsg, cleanJsonString } from "../../frontend/contents/VariaveisGlobais";

async function ConsultaTotvs( cConsulta, cTabelas, EmpresaLogada ){
    if (cConsulta == 'Usuario'){
        var lista = await ConsultaUsuario()
        
        return lista
    }
    
    const URLRest = window._env_?.REACT_APP_URL_REST + "CONSULTA";
    const Token = window._env_?.REACT_APP_TOKEN_REST;
    const EmpFilLogado = (EmpresaLogada ? EmpresaLogada : localStorage.getItem('empresaFilial') );
    const EmpresaParam = EmpFilLogado.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA);
    const FilialParam = EmpFilLogado.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL);

    const config = JSON.stringify( { consulta: cConsulta, tabelas: cTabelas, empresa: EmpresaParam, filial: FilialParam, ts: new Date().getTime() })

    // useEffect(() => {
        var lista = await axios.post(URLRest, config, {
            headers: {
                "tenantId": EmpresaParam + ',' + FilialParam,
                "Content-Type": "application/json",
                'Authorization': `Basic ${Token}`,
                "Accept" : "*/*",
                "Cache-Control": "no-cache, no-store, must-revalidate",                
            }})
            .then((response) => {
                let responseData = response.data
                
                if (typeof responseData == 'string'){
                    responseData = JSON.parse(cleanJsonString(responseData))
                }
                
                return responseData;
            })
            .catch((err) => {
                ErroMsg('Falha ao Processar Consulta!')
                return {error: "01", description:"Falha ao Processar Consulta!" + err, data: []};
            });
    // }, []);

    return lista;
}

export default ConsultaTotvs